import { StytchHeadlessClient } from '@stytch/vanilla-js/headless';
import { c as createStytchSSRProxy } from './StytchSSRProxy-34c789b5.js';

/**
 * Creates a Headless Stytch client object to call the stytch APIs.
 * The Stytch client is not available serverside.
 * @example
 * const stytch = createStytchHeadlessClient('public-token-<find yours in the stytch dashboard>')
 *
 * return (
 *   <StytchProvider stytch={stytch}>
 *     <App />
 *   </StytchProvider>
 * )
 * @returns A {@link StytchHeadlessClient}
 */
const createStytchHeadlessClient = (...args) => {
    if (typeof window === 'undefined') {
        return createStytchSSRProxy();
    }
    return new StytchHeadlessClient(...args);
};

export { createStytchHeadlessClient };
